/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_FeaturesInputs */

const en_landing_nav_features = /** @type {(inputs: Landing_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const zh_landing_nav_features = /** @type {(inputs: Landing_Nav_FeaturesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Landing_Nav_FeaturesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_nav_features = /** @type {((inputs?: Landing_Nav_FeaturesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_FeaturesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_nav_features(inputs)
	return zh_landing_nav_features(inputs)
});
export { landing_nav_features as "landing.nav.features" }